import { signOut } from 'aws-amplify/auth'
import { Link, useNavigate } from 'react-router-dom'
import { signOutUser } from '../utils'

function UserMenu() {
  const navigate = useNavigate()

  const signOutAndNavigate = async () => {
    await signOut()
    signOutUser()
    navigate('/login')
  }

  return (
    <div className="flex items-center">
      <div className="mr-2">
        <Link className="rounded-lg text-gray-300 hover:text-white group" to="/my-account">
          My&nbsp;Account
        </Link>
      </div>
      <div className="mr-2 rounded-lg text-gray-300 hover:text-white group">|</div>
      <div>
        <div
          role="button"
          className="rounded-lg text-gray-300 hover:text-white group"
          onClick={signOutAndNavigate}
          onKeyDown={signOutAndNavigate}
          tabIndex={0}
        >
          Logout
        </div>
      </div>
    </div>
  );
}

export default function AccountMenu() {
  return (
    <>
      <div className="z-50 transition-all duration-500 mr-20">
        <UserMenu />
      </div>
    </>
  );
}